import React, {useState} from 'react'
import { MiFooter } from '../../components/footer/MiFooter'
import { ContentBodyUserFeedback } from '../../components/UserFeedback/ContentBodyUserFeedback'
import './UserFeedback.css'
import { useContext } from 'react'
import { UsuarioContext } from '../../contexts/UsuarioContext'
import HeaderHome from '../../components/headerHome/HeaderHome'

export const UserFeedback = () => {
    const [MenuLateralAux, setMenuLateralAux] = useState();


    const chageMenuLateralAux = () => {
        setMenuLateralAux(!MenuLateralAux)
    }
    return (
        <>
            <div className='UserFeedback' >
                <div className='headerUserFeedback'>
                    <HeaderHome chageMenuLateralAux={chageMenuLateralAux} />
                </div>
                <div className="bodyUserFeedback">
                    <ContentBodyUserFeedback
                     MenuLateralAux={MenuLateralAux}
                        chageMenuLateralAux={chageMenuLateralAux} 
                        />
                </div>
                <div className='footerReservarServicio'>
                    <MiFooter />
                </div>
            </div>
        </>
    )
}
